import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Localized } from '../../../objects';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';

@Injectable()
export class LectionaryItemTypeService {

  private cache: LectionaryItemType[];

  constructor(private apiSvc: ApiService) { }

  public loadEntities(): Promise<LectionaryItemType[]> {

    const p = new Promise<LectionaryItemType[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("LectionaryItemType cache detected");
        resolve(this.cache);
        return;
      }

      this.apiSvc.get("api/lectionaryitemtype", null).subscribe(
        (data: LectionaryItemType[]) => {
          console.log("loadItemNames", data);
          this.cache = data;
          resolve(this.cache);
        },
        (err) => {
          console.log("error", err);
        }
      );

    });

    return p;
  }

}

export class LectionaryItemType {
  Id: number;
  Localized: Localized[];
  ReligionBranch: ReligionBranch; 
  SubTypes: LectionaryItemTypeSubType[];
  DesignatedLectionaryItemType: number;
}
export class LectionaryItemTypeSubType {
  Id: number;
  Localized: Localized[]; 
}


